import React from 'react';
import Layout from '../../components/UI/Layout/Layout'
import { useParams } from 'react-router-dom';
import CarRateForm from '../../components/Entity/Cars/CarRateForm/CarRateForm';

const CarRatePage = () => { 
  
  const { id } = useParams();

  return <Layout > 
       <CarRateForm id={id} isAdd={false}></CarRateForm>  
  </Layout>;
}

export default CarRatePage;